import { Component, EventEmitter, Input, Output } from '@angular/core';
export interface ContainerInterface {
  icon: string;
  title: string;
  description: string;
}

@Component({
  selector: 'bfd-tab-menu',
  templateUrl: './bfd-tab-menu.component.html',
  styleUrls: ['./bfd-tab-menu.component.scss'],
})
export class TabMenuComponent {
  @Input() menus: string[];
  @Input() prefix: string;
  @Output() menusEmitter: EventEmitter<string> = new EventEmitter<string>();
  public active: number = 0;
  
  public goTo(view: number): void {
    this.active = view;
    this.menusEmitter.emit(`${this.prefix}-${(this.active+1)}`);
  }
}
